import { AxiosError } from "axios";
import { Resource } from "i18next";
import { OpenHour, PlaceType } from "../interfaces_and_types";
import customFetch from "./CustomFetchFunction";
import { Url } from "./URL";

const login = async (username: string, password: string) => {
  type T = {
    ok: string;
    msg: string;
    token: string;
    place_id: number;
  };

  let returnVal: {
    ok: string;
    msg: string;
    token: string;
    place_id: number;
    status: number;
  };
  returnVal = await customFetch<T>(
    Url + "/login/",
    "POST",
    undefined,
    JSON.stringify({
      //email,
      username,
      password,
    }),
  )
    .then((result) => {
      console.log("fetch POST Auth= ", result);
      return {
        ok: result.data.ok,
        msg: result.data.msg,
        token: result.data.token,
        place_id: result.data.place_id,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "Auth error: ",
          error.response?.status,
          " ",
          error.response?.data.msg,
        );
        return error.response !== undefined
          ? {
              ok: error.response.data.ok,
              msg: error.response.data.msg,
              token: error.response.data.token,
              place_id: error.response.data.place_id,
              status: error.response.status,
            }
          : {
              ok: "server error",
              msg: "server error",
              token: "",
              place_id: -1,
              status: 500,
            };
      }
      console.error("Auth error: ", error);
      return {
        ok: "server error",
        msg: "server error",
        token: "",
        place_id: -1,
        status: 500,
      };
    });

  return returnVal;
};

const getPlace = async (token: string) => {
  type T = { place: PlaceType; message: string };

  let returnVal: { place: PlaceType | null; message: string; status: number };
  returnVal = await customFetch<T>(
    Url + `/PlacesViewset/place/details/`,
    "GET",
    token,
  )
    .then((result) => {
      console.log("fetch GET place details = ", result.data.place);
      return {
        place: result.data.place,
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "place details error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              place: error.response.data.place,
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              place: null,
              message: "server error",
              status: 500,
            };
      }
      console.error("place details error: ", error);
      return {
        place: null,
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const updateItemAvailablity = async (
  id: number,
  isAvailable: boolean,
  type: string,
  token: string,
) => {
  type T = { message: string };

  let returnVal: { message: string; status: number };

  returnVal = await customFetch<T>(
    Url + `/itemAvailable/item/update/`,
    "PUT",
    token,
    JSON.stringify({
      isAvailable: isAvailable,
      id,
      type,
    }),
  )
    .then((result) => {
      console.log("fetch PUT updateItemAvailablity= ", result.status);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "updateItemAvailablity error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("updateItemAvailablity error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const UpdateItemPrice = async (
  id: number,
  price: number,
  type: string,
  token: string,
) => {
  type T = { message: string };

  let returnVal: { message: string; status: number };

  returnVal = await customFetch<T>(
    Url + `/itemPrice/item/update/`,
    "PUT",
    token,
    JSON.stringify({
      id,
      price,
      type,
    }),
  )
    .then((result) => {
      console.log("fetch PUT updateItemPrice= ", result.status);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "updateItemPrice error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("updateItemPrice error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const getPlaceBudget = async (
  token: string,
  periodStart: Date,
  periodEnd: Date,
) => {
  type T = {
    total: number;
    totalCash: number;
    totalCard: number;
    totalOrders: number;
    message: string;
  };

  let returnVal: {
    total: number;
    totalCash: number;
    totalCard: number;
    totalOrders: number;
    message: string;
    status: number;
  };
  returnVal = await customFetch<T>(
    Url + `/getOrdersList/place/orders/budget/`,
    "POST",
    token,
    JSON.stringify({
      periodStart,
      periodEnd,
    }),
  )
    .then((result) => {
      console.log("fetch GET place details = ", result);
      return {
        total: result.data.total,
        totalCash: result.data.totalCash,
        totalCard: result.data.totalCard,
        totalOrders: result.data.totalOrders,
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "place details error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              total: error.response.data.total,
              totalCash: error.response.data.totalCash,
              totalCard: error.response.data.totalCard,
              totalOrders: error.response.data.totalOrders,
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              total: 0,
              totalCash: 0,
              totalCard: 0,
              totalOrders: 0,
              message: "server error",
              status: 500,
            };
      }
      console.error("place details error: ", error);
      return {
        total: 0,
        totalCash: 0,
        totalCard: 0,
        totalOrders: 0,
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const GetTranslations = async (token: string | null) => {
  type T = { resource: Resource; message: string };

  let returnVal: { resource: Resource | null; message: string; status: number };

  returnVal = await customFetch<T>(
    Url + `/translations/get/`,
    "GET",
    token ? token : undefined,
  )
    .then((result) => {
      console.log("fetch GET GetTranslations= ", result);
      return {
        resource: result.data.resource,
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "place details error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              resource: error.response.data.resource,
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              resource: null,
              message: "server error",
              status: 500,
            };
      }
      console.error("place details error: ", error);
      return {
        resource: null,
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const saveNotificationToken = async (
  token: string,
  notificationToken: string,
  deviceID?: string,
) => {
  type T = { message: string };

  let returnVal: { message: string; status: number };
  returnVal = await customFetch<T>(
    Url + `/place/update/notifications_token`,
    "PUT",
    token,
    JSON.stringify({
      token: notificationToken,
      ...(deviceID && { deviceID }),
    }),
  )
    .then((result) => {
      console.log("fetch POST save_notification_token= ", result.status);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "save_notification_token error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("save_notification_token error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

const setPlaceOpenTime = async (token: string | null, openHour: OpenHour) => {
  type T = { openHour: OpenHour; message: string };

  let returnVal: { message: string; status: number };

  returnVal = await customFetch<T>(
    Url + `/placeOpenTimes/item/set/`,
    "POST",
    token ? token : undefined,
    JSON.stringify(openHour),
  )
    .then((result) => {
      console.log("fetch POST setPlaceOpenTime= ", result);
      return {
        message: result.data.message,
        status: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "setPlaceOpenTime error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              message: error.response.data.message,
              status: error.response.status,
            }
          : {
              message: "server error",
              status: 500,
            };
      }
      console.error("setPlaceOpenTime error: ", error);
      return {
        message: "server error",
        status: 500,
      };
    });

  return returnVal;
};

/** WORKING=1 (available), BUSY=2 */
const setPlaceStatus = async (token: string | null, status: number) => {
  type T = { status: number; message: string };

  let returnVal: { status: number; message: string; httpStatus: number };

  returnVal = await customFetch<T>(
    Url + `/place/status/set/`,
    "POST",
    token ? token : undefined,
    JSON.stringify({ status }),
  )
    .then((result) => {
      return {
        status: result.data.status,
        message: result.data.message,
        httpStatus: result.status,
      };
    })
    .catch((error: AxiosError<T>) => {
      if (error.isAxiosError) {
        console.error(
          "setPlaceStatus error: ",
          error.response?.status,
          " ",
          error.response?.data.message,
        );
        return error.response !== undefined
          ? {
              status: error.response.data.status,
              message: error.response.data.message,
              httpStatus: error.response.status,
            }
          : {
              status: -1,
              message: "server error",
              httpStatus: 500,
            };
      }
      console.error("setPlaceStatus error: ", error);
      return {
        status: -1,
        message: "server error",
        httpStatus: 500,
      };
    });

  return returnVal;
};

export {
  getPlace,
  updateItemAvailablity,
  login,
  getPlaceBudget,
  GetTranslations,
  UpdateItemPrice,
  setPlaceOpenTime,
  setPlaceStatus,
  saveNotificationToken,
};
